import { css } from "@emotion/react";

export const dropdownBtn = css`
  border: 0;
  background-color: transparent;
`;

export const dropdownContent = css`
  max-height: 15rem;
`;
